/**
 * NOTE: this file exists only to prevent older projects from breaking, if they still use this import path.
 */
console.log(
    `DEPRECATION WARNING: you're importing a path that is no longer used "@webiny/app-page-builder/editor/plugins/elementSettings/advanced". You should remove this import from your apps.`
);
export default [];
